import {maxItemsOSM} from 'config';
import {slugify} from 'utils';
import PromotionFactory from 'factories/Promotion';
import {translateFlag} from 'config/constants';
import { ecommerce } from 'config/constants';

const create = (product) => {

    if(product.factory) return product;

    product.promotions = {};

    const ppum = product.PPUM && product.PPUM.length ? parseFloat(product.PPUM[0].replace(',', '.')) : 0;

    product.items.map((item) => {
        let unitSale = false;
        if(product['Pesable x Unidad']){
            unitSale = translateFlag[product['Pesable x Unidad'][0]];
        }

        if (!product.SkuData || (Array.isArray && Array.isArray(product.SkuData) && product.SkuData.length === 0)) {
            return skuDataFallback(ppum, unitSale, item);
        }else{
            let skuData = null;
            if(Array.isArray(product.SkuData)){
                skuData = _getJson(product.SkuData[0], null);
            }else{
                skuData = product.SkuData;
            }

            if(!skuData){
                return skuDataFallback(ppum, unitSale, item);
            }

            product.SkuData = skuData;
            product.promotions[item.itemId] = skuData[item.itemId] ? skuData[item.itemId].promotions : [];

            item.maxItems = _getMaxItems(skuData, item, product);
            if(item.maxItems > maxItemsOSM){
                item.maxItems = maxItemsOSM;
            }
            item.prices = _prices(item, skuData[item.itemId],unitSale);
            item.skuData = skuData[item.itemId];
            if(item?.skuData?.unit_multiplier_un) item.skuData.unit_multiplier_un = ppum ? ppum : item?.skuData?.unit_multiplier_un;

        }
    });

    for (var key in product) {
        if (key === "Flag Nutricional") {

            product.flag_nutricional = product[key].map((item) => {
                if (item === "Alto en Grasas Saturadas") {
                    return "nutritional-info__flag--grasas-saturadas";
                } else if (item === "Alto en Azúcares") {
                    return "nutritional-info__flag--azucares";
                } else if (item === "Alto en Calorías") {
                    return "nutritional-info__flag--calorias";
                } else if (item === "Alto en Sodio") {
                    return "nutritional-info__flag--sodio";
                }
            });

        }

        if (key === "Información Nutricional (por 100 g / por porción)") {
            if (product[key] && product[key].findIndex((val) => val === "Flag Nutricional") !== -1) {
                product[key].splice(product[key].findIndex((val) => val === "Flag Nutricional"), 1);
            }

            product.flag_details = product[key];
        }

        if (key == "Ficha Técnica") {
            product.flag_technical = product[key];
        }

        product = _getClusters(product);


    }
    product.factory = true;
    return product;

}

const skuDataFallback = (ppum, unitSale, item) => {
    if(!(item.skuData && item.skuData.unit_multiplier_un)){
        item.skuData = {
            unit_multiplier_un: ppum ? ppum : 1
        }
    }

    item.prices = _prices(item, item.skuData,unitSale);
    return item;
}

const _getJson = (data, fallback = []) => {
    try{
        return JSON.parse(data);
    } catch (e){
        return fallback;
    }
}

const _getMaxItems = (_skuData, _item, _product) => {
    if (ecommerce.whiteLabel){
        if(_product["Cart Limit SISA"]){
            return parseInt(_product["Cart Limit SISA"])
        }else return _skuData[_item.itemId] && _skuData[_item.itemId].cart_limit ? parseInt(_skuData[_item.itemId].cart_limit) : maxItemsOSM
    }else{
        return _skuData[_item.itemId] && _skuData[_item.itemId].cart_limit ? parseInt(_skuData[_item.itemId].cart_limit) : maxItemsOSM
    }
}

const _getClusters = (product) => {
    if (product.clusterHighlights) {
        const clusters = Object.values(product.clusterHighlights);
        let classList = [];

        clusters.map(cluster => {
            let lowerCluster = cluster.toLowerCase();
            const name = slugify(lowerCluster.replace(' | jumbo.cl', ''));
            if(name.substring(0,5) === 'flag-'){
                classList.push(name);
            }
            return cluster;
        });

        product.items = product.items.map(item => {
            const skuData = product.SkuData ? (product.SkuData[item.itemId] || null) : null;
            let itemClassList = classList;

            if (skuData && skuData.release_data) {
                const dateStart = _getDate(skuData.release_data.date_release);
                const dateEnd = _getDate(skuData.release_data.date_release_end);
                const currentDate = new Date();

                if ((dateStart && dateEnd && currentDate >= dateStart && currentDate <= dateEnd) || skuData.release_data['is_new']) {
                    itemClassList = itemClassList.concat(['flag-producto-nuevo'])
                }
            }

            item.clusterClass = itemClassList;

            return item;
        });
    }

    return product;
}

const _getDate = (text) => {
    if (!text) return null;
    const splitText = text.split(" ");
    text = splitText[0] || null;
    const dateArray = text ? text.split("-") : null;
    return text ? new Date(`${dateArray[2]}-${dateArray[1]}-${dateArray[0]} ${splitText[1]}`) : null;
}

const setPromotions = (product, objectPromotions) => {
    return PromotionFactory.setProductPromotions(product, objectPromotions);
}

const _prices = (item, skuData = null, unitSale = false) => {
    const commertialOffer = item && item.sellers && item.sellers[0] ? item.sellers[0].commertialOffer : false;

    const old = commertialOffer ? ((commertialOffer.PriceWithoutDiscount || commertialOffer.ListPrice) * item.unitMultiplier) : 0;
    const regular = commertialOffer ? (commertialOffer.Price * item.unitMultiplier) : 0;
    if(!unitSale) {
        return {
            old,
            oldPpum: skuData ? Math.round(old / skuData.unit_multiplier_un) : 0,
            regular,
            regularPpum: skuData ? Math.round(regular / skuData.unit_multiplier_un) : 0
        }
    }else{
        return {
            old,
            oldPpum: skuData ? Math.round(old / item.unitMultiplier) : 0,
            regular,
            regularPpum: skuData ? Math.round(regular / item.unitMultiplier) : 0
        }
    }
}

const orderItemPrices = (item, skuData = null, unitSale = false) => {
    const old = (item.price * item.unitMultiplier) / 100;
    const regular = item.sellingPrice / 100;

    if(!unitSale) {
        return {
            old: Math.round(old),
            oldPpum: skuData ? Math.round(old / skuData.unit_multiplier_un) : 0,
            regular,
            regularPpum: skuData ? Math.round(regular / skuData.unit_multiplier_un) : 0
        }
    }
    else{
        return {
            old: Math.round(old),
            oldPpum: skuData ? Math.round(old / item.unitMultiplier) : 0,
            regular,
            regularPpum: skuData ? Math.round(regular / item.unitMultiplier) : 0
        }
    }
}

const splitProducts = (products) => {
    if(!products && products.length) return false;

    let sellers = []
    products.map(prod => {
        let sellerId = null
        if (prod.items[0]) {
            sellerId = prod.items[0].sellers[0] ? prod.items[0].sellers[0].sellerId : null
            prod.items[0].sellerId = sellerId;

            const sellerIndex = sellers.findIndex(sell => sell.id === sellerId);

            if(sellerIndex == -1){
                sellers.push({id: sellerId, prods: [prod]})
            }else{
                sellers[sellerIndex].prods.push(prod);
            }
        }
    });

    return sellers;

}

const splitItems = (items, isProducts = true) => {
    if(!(items && items.length)) return false;

    let sellers = []
    items.map(item => {
        let sellerId = null;
        const validation = isProducts ? item.items[0] : item.seller;
        if (validation) {
            if(isProducts){
                sellerId = item.items[0].sellers[0] ? item.items[0].sellers[0].sellerId : null
            }else{
                sellerId = item.seller;
            }
            

            const sellerIndex = sellers.findIndex(sell => sell.id === sellerId);

            if(sellerIndex == -1){
                sellers.push({id: sellerId, prods: [item]})
            }else{
                sellers[sellerIndex].prods.push(item);
            }
        }
    }) ;

    sellers.sort((a, b) => {
        if (a.id < b.id) {
            return -1
        } else {
            return 1
        }
    });

    return sellers;

}

const formatWeight = (ItemUnit, weight) => {
    let measurementUnit = '';

    if(ItemUnit === 'kg' && weight < 1) {
        measurementUnit = ' g';
    } else {
        measurementUnit = ` ${ItemUnit}`;
    }

    let realWeight = weight

    if(weight < 1) {
        realWeight = weight * 1000
    }

    return realWeight + measurementUnit;
}

const formatProducts = (item) => {
    let quantity = '';
    
    quantity = item ? item.reduce((accumulator, item) => {
        if(item.measurementUnit === 'kg'){
            return accumulator + 1
        }
        return accumulator + item.quantity
    } , 0) : 0;
    
    return quantity;
}

const hasStock = (itemData) => {
    if (!itemData) return false;
    const commertialOffer = (itemData.sellers && itemData.sellers[0]) ? itemData.sellers[0].commertialOffer : false;
    return !!(commertialOffer && commertialOffer.ListPrice !== 0 && commertialOffer.AvailableQuantity && commertialOffer.AvailableQuantity > 0);
}

const ProductFactory = {
    create,
    setPromotions,
    orderItemPrices,
    splitProducts,
    splitItems,
    formatWeight,
    hasStock,
    formatProducts
}

export default ProductFactory;
